import { render, staticRenderFns } from "./LoadImage.vue?vue&type=template&id=137879b3&"
import script from "./LoadImage.vue?vue&type=script&lang=js&"
export * from "./LoadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports